/** @jsxImportSource @emotion/react */
import * as React from 'react';

import { bodyBaseCss } from './styles';

export interface ModalBodyProps {
  className?: string;
  children?: React.ReactNode;
  tag?: React.ElementType;
}

const ModalBody = ({ className, children, tag: Tag = 'div' }: ModalBodyProps): React.JSX.Element => (
  <Tag css={bodyBaseCss} className={className}>
    {children}
  </Tag>
);

export default ModalBody;
